import LayoutContainer from 'components/Common/LayoutContainer'
import Divider from 'LuxKit/Divider'
import MessageBanner from 'LuxKit/Banners/MessageBanner'
import { useMemo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import zIndex from 'styles/tools/z-index'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import ChatHeader from 'supportAssistant/components/Chat/ChatHeader'
import ChatContent from 'supportAssistant/components/Chat/ChatContent'
import ChatEmptyState from 'supportAssistant/components/Chat/ChatEmptyState'
import MessageInput from 'supportAssistant/components/Chat/MessageInput'
import useChatState from 'supportAssistant/hooks/useChatState'
import { useSimplePolling } from 'supportAssistant/hooks/useSimplePolling'
import { useAppSelector } from 'hooks/reduxHooks'
import { selectOutageMessage } from 'supportAssistant/selectors/selectCurrentChat'

const Container = styled.div`
  height: calc(100dvh - ${props => props.theme.layout.headerRelativeOffset});
  display: flex;
  flex-direction: column;
`

const Body = styled(LayoutContainer)`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding-bottom: ${rem(12)};
`

const HeaderContainer = styled(LayoutContainer)`
  flex-shrink: 0;
  background-color: ${props => props.theme.palette.neutral.default.eight};
  z-index: ${zIndex.min};
`

function Chat() {
  const [messages, typing, , fetchingChatMessages] = useChatState()
  const outageMessage = useAppSelector(selectOutageMessage)
  const hasUserMessage = useMemo(() => messages.some(m => m.sender === 'user'), [messages])
  const isEmptyState = !fetchingChatMessages && !hasUserMessage

  useSimplePolling()

  return (
    <Container>
      <HeaderContainer>
        <ChatHeader />
        <Divider direction="horizontal" kind="primary" />
      </HeaderContainer>
      {outageMessage && (
        <LayoutContainer size="md">
          <MessageBanner kind="critical">{outageMessage}</MessageBanner>
        </LayoutContainer>
      )}
      <Body size="md">
        {isEmptyState && <ChatEmptyState
          isTyping={typing}
          actions={messages[0]?.meta?.content}
          payload={messages[0]?.meta?.payload}
        />}
        {!isEmptyState && <>
          <ChatContent />
          {fetchingChatMessages && <LoadingBox style={{ height: rem(44), width: '100%' }} />}
          {!fetchingChatMessages && <MessageInput isTyping={typing} />}
        </>}
      </Body>
    </Container>
  )
}

export default Chat
